<template>
    <div class="row">
        <div class="kedvenciam_all_area for_nw_form">
            <div class="col-sm-12">
                <div class="single_kedvenciam_all mobile-padding">
                    <div class="row">
                        <div class="col-sm-3">
                            <div class="vezteknev_title">
                                <h6>Vezetéknév*:</h6>
                            </div>
                        </div>
                        <div class="col-sm-9">
                            <div class="form-group" :class="{'has-error': errors.has('lastname') }">
                                <input data-vv-validate-on="blur" name="lastname" v-validate="'required|min:2'" class="form-control my-input" type="name" placeholder=""  required="" v-model="data.lastName">
                                <span v-show="errors.has('lastname')" class="span-err">A vezetéknévnek minimum 2 karakter hosszúnak kell lennie</span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-3">
                            <div class="vezteknev_title">
                                <h6>Keresztnév*:</h6>
                            </div>
                        </div>
                        <div class="col-sm-9">
                            <div class="form-group" :class="{'has-error': errors.has('firstname') }">
                                <input data-vv-validate-on="blur" name="firstname" v-validate="'required|min:2'" class="form-control my-input" type="name" placeholder=""  required="" v-model="data.firstName">
                                <span v-show="errors.has('firstname')" class="span-err">A keresztnévnek minimum 2 karakter hosszúnak kell lennie</span>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="row">
                        <div class="col-sm-3">
                            <div class="vezteknev_title">
                                <h6>Név előtag (ha van):</h6>
                            </div>
                        </div>
                        <div class="col-sm-9">
                            <div class="form-group">
                                <input data-vv-validate-on="blur" class="form-control my-input" type="name" placeholder=""  v-model="data.otherName">
                            </div>
                        </div>
                    </div> -->
                    <div class="row">
                        <div class="col-sm-3">
                            <div class="vezteknev_title">
                                <h6>Telefonszám*:</h6>
                            </div>
                        </div>
                        <div class="col-sm-9">
                            <div class="form-group" :class="{'has-error': errors.has('phone') }">
                                <input data-vv-validate-on="blur" name="phone" v-validate="{ required: true, regex: /^\+?[0-9]{6,12}$/ }" class="form-control my-input" type="name" placeholder=""  required="" v-model="data.phone">
                                <span v-show="errors.has('phone')" class="span-err">A telefonszám csak számokat tartalmazhat szóközök nélkül és egy + jelet az elején (min 6, max 12 karakter)</span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-3">
                            <div class="vezteknev_title">
                                <h6>Cím*:</h6>
                            </div>
                        </div>
                        <!-- /^[0-9]{4}$/ -->
                        <div class="col-sm-2 col-xs-4">
                            <div class="form-group" :class="{'has-error': errors.has('zipcode') }">
                                <label style="font-weight:normal; font-size:12px;" for="" >Ir. szám*:</label>
                                <input data-vv-validate-on="blur" name="zipcode" v-validate="'required|digits:4'" class="form-control my-input" type="text" placeholder=""  required="" v-model="data.zipCode">
                                <span v-show="errors.has('zipcode')" class="span-err">Az irányítószámnak egy 4 jegyű számnak kell lennie</span>
                            </div>
                        </div>
                        <div class="col-sm-3 col-xs-8">
                            <div class="form-group" :class="{'has-error': errors.has('city') }">
                                <label style="font-weight:normal; font-size:12px;" for="">Település*:</label>
                                <input data-vv-validate-on="blur" name="city" v-validate="'required|min:2'" class="form-control my-input" type="text" placeholder=""  required="" v-model="data.city">
                                <span v-show="errors.has('city')" class="span-err">A város neve nem megfelelő</span>
                            </div>
                        </div>
                        <div class="col-sm-4 col-xs-12">
                            <div class="form-group" :class="{'has-error': errors.has('address') }">
                                <label style="font-weight:normal; font-size:12px;" for="">Utca, házszám*:</label>
                                <input data-vv-validate-on="blur" name="address" v-validate="'required|min:4'" class="form-control my-input" type="text" placeholder=""  required="" v-model="data.address">
                                <span v-show="errors.has('address')" class="span-err">A utca, házszám nem megfelelő</span>
                            </div>
                        </div>
                    </div>
                    <div class="row" >
                        <div class="col-sm-3">
                            <div class="vezteknev_title">
                                <h6>Cég név:</h6>
                            </div>
                        </div>
                        <div class="col-sm-9">
                            <div class="form-group" :class="{'has-error': errors.has('company') }">
                                <input data-vv-validate-on="blur" name="company" class="form-control my-input" type="text" placeholder="" v-model="data.companyName">
                                <span v-show="errors.has('company')" class="span-err">A cégnévnek minimum 2 karakter hosszúnak kell lennie</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default{
    props:['data']
}
</script>

<style>
@media(max-width:767px){
  .mobile-padding{
      padding: 20px !important;

  }
}
</style>



// WEBPACK FOOTER //
// Data.vue?3edd9fe7